// utility functions
import dayjs from 'dayjs';

import localizedFormat from 'dayjs/plugin/localizedFormat';

// Расширяем dayjs плагином для поддержки системных форматов (L, LL, LLL, etc.)
dayjs.extend(localizedFormat);

const systemLocale = typeof window !== 'undefined' ? window.navigator.language.split('-')[0] : 'en';
dayjs.locale(systemLocale);

/**
 * Форматирует дату с помощью dayjs.
 * @param date - Объект Date, строка или число.
 * @param format - Строка формата. По умолчанию 'L LT' (системная дата и время)
 */
export function formatDateTime(
  date: Date | string | number | undefined | null, 
  format: string = 'L LT' 
): string {
  if (!date) return '';

  const d = dayjs(date);
  
  if (!d.isValid()) return '';

  // 'L' — это системный формат даты (напр. 23.02.2026)
  // 'LT' — это системный формат времени (напр. 12:38)
  return d.format(format);
}





/**
 * Форматирует дату с помощью dayjs.
 * @param date - Объект Date, строка или число.
 * @param format - Строка формата (по умолчанию 'DD.MM.YYYY HH:mm')
 */
export function formatDateTime__(
  date: Date | string | number | undefined | null, 
  format: string = 'DD.MM.YYYY HH:mm'
): string {
  if (!date) return '';

  const d = dayjs(date);
  
  if (!d.isValid()) return '';

  return d.format(format);
}

export function formatDateTime_(date: Date | undefined) {
  
    if (!date) return '';

    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
